export const statusGetter = (params) => {
  const data = params?.data;
  if (!data?.active) {
    return "Cancelled";
  }
  // Check if booking has hazardous materials and is pending approval
  const normalizedStatus = data?.approval?.status?.toString().toUpperCase();
  if (
    data?.hazardousDeclaration?.hasHazardousMaterials &&
    normalizedStatus === "PENDING"
  ) {
    return "Pending";
  }
  return "Active";
};
